import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { DialogDataService } from '../../dialog/dialog-data.service';
import { QuestionDefinition } from '../../forms/form.types';
import { GenericFormGroupComponent } from '../../forms/generic-form-group.component';
import { CourseService } from '../../shared/course.service';
import { Course } from '../../shared/interface/course.interface';
import { AlertService } from '../../shared/services/alert.service';
import { EmailTemplateService } from '../../site-admin/email-template/email-template.service';
import { CourseDialogData } from '../roster.types';

@Component({
    selector: 'app-roster-email-class',
    templateUrl: './email-class.component.html',
    styleUrls: ['./email-class.component.scss']
})
export class EmailClassComponent extends GenericFormGroupComponent implements OnInit {
    controls: {
        termCode: FormControl<string>;
        crn: FormControl<string>;
        subject: FormControl<string>;
        body: FormControl<string>;
        toEmails: FormControl<Array<string>>;
        ccEmails: FormControl<Array<string>>;
    };

    questions: {
        subject: QuestionDefinition;
        body: QuestionDefinition;
        toEmails: QuestionDefinition;
        ccEmails: QuestionDefinition;
    };
    course: Course;

    constructor(
        private dataService: DialogDataService<CourseDialogData>,
        private courseService: CourseService,
        private emailTemplateService: EmailTemplateService,
        private alert: AlertService,
        protected renderer2: Renderer2
    ) {
        super(renderer2);
        this.courseService.show(dataService.data.termCode, { crn: dataService.data.crn }).subscribe((v) => {
            this.course = v;
        });
        this.initControlsQuestions();
    }

    ngOnInit(): void {}

    private initControlsQuestions() {
        this.controls = {
            termCode: new FormControl<string>(this.dataService.data.termCode),
            crn: new FormControl<string>(this.dataService.data.crn),
            subject: new FormControl<string>(null, Validators.required),
            body: new FormControl<string>(null, Validators.required),
            toEmails: new FormControl<Array<string>>([]),
            ccEmails: new FormControl<Array<string>>([])
        };
        this.createFormGroup(this.controls);
        this.questions = {
            subject: {
                input: {
                    discriminator: 'TEXT',
                    property: 'subject',
                    control: this.controls.subject,
                    required: true
                }
            },
            body: {
                input: {
                    discriminator: 'RICH-TEXT',
                    property: 'body',
                    control: this.controls.body,
                    required: true
                }
            },
            toEmails: {
                prompts: [
                    {
                        text: 'Additionally Send To (optional)'
                    }
                ],
                input: {
                    discriminator: 'CHIP-LIST',
                    property: 'to',
                    control: this.controls.toEmails,
                    basicList: true
                }
            },
            ccEmails: {
                prompts: [
                    {
                        text: 'CC email addresses (optional)'
                    }
                ],
                input: {
                    discriminator: 'CHIP-LIST',
                    property: 'CC',
                    control: this.controls.ccEmails,
                    basicList: true
                }
            }
        };
    }

    sendEmail() {
        this.setSaving();
        this.courseService.sendEmail(this.getFormValue()).subscribe({
            next: () => {
                this.setDoneSaving();
                this.alert.toastSuccess('Email Sent!');
            },
            error: (err) => {
                this.setDoneSaving();
                this.alert.toastErrorObject(err);
            }
        });
    }
}
